import { UseMutationOptions } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { ExportedEntity, ExporterEntity, ExportOverrideData } from '@playq/octopus2-apps';
import { CredentialsID } from '@playq/octopus2-auth';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

type UseExporterExportPayload = {
  entity: ExporterEntity;
  creds: CredentialsID;
  override: ExportOverrideData;
};

export const useExporterExport = (
  options?: UseMutationOptions<ExportedEntity, GenericFailure | Error, UseExporterExportPayload>
) =>
  useEitherMutation(({ entity, creds, override }) => services2.exporterService.export(entity, creds, override), {
    ...options,
  });
